import React from 'react';
import "./ContactMe.css";
import resume from "./Isuru_Nirash_Resume.pdf";
import contactsImg from "../Images/contactImg.png";
import contactsMobileImg from "../Images/tech_images/contactImg.png";

import MediaQuery from 'react-responsive';

function ContactMeSection() {
  return (
    <section className="secSeven">
      <div>
        <div className="contact-me-container">

          <MediaQuery minDeviceWidth={1224} values={{ deviceWidth: 1600 }}>
            <div className="vh">
              <img className="width" src={contactsImg} alt="contactsImg" style={{ width: '950px', height: 'auto', margin: '0', display: 'flex', alignItems: 'center' }} />
            </div>
          </MediaQuery>

          <MediaQuery maxDeviceWidth={1224}>
            <div className="vh">
              <img className="width" src={contactsMobileImg} alt="contactsMobileImg" style={{ width: '100%', height: 'auto', margin: '0', display: 'flex', alignItems: 'center' }} />
            </div>
          </MediaQuery>

          <ul className="contact-list">
            <h2 className="imageAnimationLeftRight">Contact Me</h2>
            <li>
              Phone: <a href="tel:+94776795183" target="_blank" rel="noopener noreferrer">+971 543957306</a>
            </li>
            <li>
              Email: <a href="mailto:isurunirash@gmail.com" target="_blank" rel="noopener noreferrer">isurunirash@gmail.com</a>
            </li>
            <li>
              GitHub: <a href="https://github.com/IsuruNirash" target="_blank" rel="noopener noreferrer">IsuruNirash</a>
            </li>
            <li>
              LinkedIn: <a href="https://www.linkedin.com/in/isuru-nirash-aa54611b8" target="_blank" rel="noopener noreferrer">Isuru Nirash</a>
            </li>
            <li>
              Portfolio: <a href="https://www.behance.net/Isuru_Nirash" target="_blank" rel="noopener noreferrer">Isuru Nirash</a>
            </li>
            <li>
              Research Publication: <a href="https://ieeexplore.ieee.org/document/9998201" target="_blank" rel="noopener noreferrer">IEEE Xplore</a>
            </li>
            <li>
              <a href={resume} download target="_blank" rel="noopener noreferrer">Download Resume (PDF)</a>
            </li>
          </ul>

          <div class="bottom-left">Copyright @2024 Isuru Nirash All rights reserved.</div>
          <div class="bottom-right MblH">Crafted with fervor and innovation</div>

        </div>
      </div>
    </section>
  );
}

export default ContactMeSection;
